import manageNav from '../../../../../assets/images/support/supervised-nps/manage-nav.png';
import providersList from '../../../../../assets/images/support/supervised-nps/providers-list.png';
import profilePanel from '../../../../../assets/images/support/supervised-nps/profile-panel.png';
import activityPanel from '../../../../../assets/images/support/supervised-nps/activity-panel.png';

export const content = `If you're a collaborating physician, use this guide to find the nurse practitioners (NPs) you supervise and review their profile details.

> Names, photos, and contact details in the screenshots below are blurred. Your NPs, states, and activity may be different.

## Step 1: Open Manage

In the top navigation, select the people icon between the ID-card and question-mark icons. This opens the [**Manage**](/collaboration/manage) page.

![Select the people icon to open Manage](${manageNav})

## Step 2: Find and select an NP

1. On the **Manage** page, scroll down past **Tasks** to the **Providers** section.
2. Use **Search providers** to search by name, or the **All States** dropdown to narrow the list.
3. Select the NP's name or row to open their profile.

![The Providers section includes a search field and a state filter](${providersList})

> Use **Search providers** in this section, not **Search clients** at the top of the platform.

## Step 3: Review the profile panel

The NP's profile shows contact information and collaboration details on the left, and **Activity** on the right.

* **Name and credentials:** Confirm you opened the correct NP profile.
* **Contact information:** The NP's email address and any work or mobile numbers.
* **Licensed:** The states where the NP is licensed.
* **Collaborative States:** The states where you collaborate with this NP.
* **Manage Details:** The state section beneath the contact panel, including when the next supervision meeting is due.

![Left-hand profile panel](${profilePanel})

## Step 4: Check the Activity panel

On the right, select **All states** or a specific state to filter the activity view. Supervision meetings you record appear here.

![Activity appears on the right side of the NP profile](${activityPanel})

To view another NP, select the people icon to return to **Manage**, then scroll back to **Providers**.

## Related articles

* [How do I record a supervision meeting?](/support/articles/supervision-meeting)
* [How do I complete chart reviews?](/support/articles/chart-reviews)
`;
